import { takeEvery, call, put, all } from 'redux-saga/effects';
import {
  updateList,
  sendRequest,
  initState
} from '../../../../common/reducers/_list/reducer';
import {
  requestInProcess,
  requestFinished,
  setCodeResponse,
  initState as initRequestStatusState
} from '../../../../common/reducers/_requestStatus/reducer';
import { timeoutCall } from '../../../../utils/sagaHalper';
import UserOutputAccountsService from '../../services/UserOutputAccountsService';

function* getAuthUserOutputAccounts(reducerName) {
  yield put(requestInProcess(reducerName));
  try {
    const result = yield call(
      timeoutCall,
      UserOutputAccountsService.getAuthUserOutputAccounts
    );
    if (result.response) {
      yield put(setCodeResponse(reducerName, result.response.status));
      if (result.response.status) {
        yield put(
          updateList(reducerName, {
            itemsById: result.destructData.itemsById,
            itemsIds: result.destructData.itemsIds
          })
        );
      }
    }
  } catch (error) {
    console.log(error);
  }
  yield put(requestFinished(reducerName));
}

function* initStates(reducerName) {
  yield put(initRequestStatusState(reducerName));
}

export default function* createSaga(reducerName) {
  yield all([
    takeEvery(
      sendRequest(reducerName).type,
      getAuthUserOutputAccounts,
      reducerName
    ),
    takeEvery(initState(reducerName).type, initStates, reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/authUserOutputCash/combines/authUserOutputAccounts/saga.js